<!-- 设置权限模板 -->
<template>
	<div>
		<el-dialog id="qx" :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" append-to-body
			center :close-on-click-modal="false" width="80%" top="1rem">
			<el-form ref="form" label-position="top" label-width="120px" size="mini">
				<el-form-item label="权限模板名称">
					<el-input v-model="sendDataInfo.jteName"></el-input>
				</el-form-item>
				<el-tabs tab-position="left" type="border-card" v-model="activeName" @tab-click="handleClick"
					style="max-height: 450px;overflow-y: auto;">
					<el-tab-pane v-for="(menuOne,menuOneKey) in menuList" :label="menuOne.label" :key="menuOneKey">
						<el-tree ref="menuTree" :data="[menuOne]" :show-checkbox="true" :check-strictly="true"
							@check="handleCheckChange" :expand-on-click-node='false' node-key="jurId" 
							:props="defaultProps" highlight-current  :default-expanded-keys="[menuOne.jurId]">
						</el-tree>
					</el-tab-pane>
				</el-tabs>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="saveJurisdiction()">保存</el-button>
			</div>
		</el-dialog>
	</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name: 'settingJurisdictionTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dataActionBox: {
				showStatus: false,
				boxTitle: '新增' || '修改',
				actionType: 0, // 0新增，1修改
			},
			menuList: [],
			sendDataInfo: {
				jteId: '',
				jteName: '',
				jurtemre: [],
			},
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			activeName: '',
			tabIndex: 0,
			checkedId: [],
			userJurisdiction: []
		};
	},
	//监听属性 类似于data概念
	computed: {
	},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {
		// tree 发生点击 变化时
		// 统一处理子节点为相同的勾选状态
		uniteChildSame(treeList, isSelected) {
			if (isSelected) {
				this.userJurisdiction.push(treeList.jurId)
			} else {
				this.userJurisdiction.forEach((item,index)=>{
					if (item == treeList.jurId) {
						this.userJurisdiction.splice(index,1)
					}
				})
			}
			this.$refs.menuTree[this.tabIndex].setChecked(treeList.jurId, isSelected);
			if (!treeList.children) return
			for (let i = 0; i < treeList.children.length; i++) {
				this.uniteChildSame(treeList.children[i], isSelected);
			}
		},
		// 统一处理父节点为选中
		selectedParent(currentObj) {
			let currentNode = this.$refs.menuTree[this.tabIndex].getNode(currentObj);
			if (currentNode.parent.key !== undefined) {
				if (!this.userJurisdiction.includes(currentNode.parent.data.jurId)) this.userJurisdiction.push(currentNode.parent.data.jurId)
				this.$refs.menuTree[this.tabIndex].setChecked(currentNode.parent, true);
				this.selectedParent(currentNode.parent);
			}
		},
		handleCheckChange(currentObj, treeStatus) {
			console.log(currentObj, treeStatus)
			// 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
			let selected = treeStatus.checkedKeys.indexOf(currentObj.jurId); // -1未选中,>=0为选中
			// 选中
			if (selected !== -1) {
				// 子节点只要被选中父节点就被选中(需要选中父节点时候调用此方法)
				this.selectedParent(currentObj);
				// 统一处理子节点为相同的勾选状态
				this.uniteChildSame(currentObj, true);
			} else {
				this.userJurisdiction.forEach((item,index)=>{
					if (item == currentObj.jurId) {
						this.userJurisdiction.splice(index,1)
					}
				})
				// 未选中 处理子节点全部未选中
				if (!currentObj.children) return
				if (currentObj.children.length !== 0) {
					this.uniteChildSame(currentObj, false);
				}
			}
		},
		handleClick(tab, event) {
			this.tabIndex = Number(tab.index)
			this.$refs.menuTree[this.tabIndex].setCheckedKeys(this.userJurisdiction)
		},
		handleCheckAllChange(levOne, levTwo) {

		},
		// 获取权限
		async getJurisdictionList() {
			let responseData = await this.$http.getJurisdictionList({ jurType: 0 })  //权限类型权限类型0.erp1.协同
			if (responseData.status == 200) {
				this.menuList = this.handleJurisdiction(responseData.result)
			} else {
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}

		},


		// 保存权限
		async saveJurisdiction() {
			if (this.sendDataInfo.jteName == '') {
				this.$message({
					message: '请填写名称',
					type: 'error'
				});
				return false
			}
			this.sendDataInfo.jurtemre = []
			// let res = []
			// this.menuList.forEach((item, index) => {
			// 	res = res.concat(this.$refs.menuTree[index].getCheckedNodes())
			// })
			// console.log('res',res)
			this.userJurisdiction = [...new Set(this.userJurisdiction)]
			this.userJurisdiction.forEach((key, i) => {
				this.sendDataInfo.jurtemre.push(key)
			})
			if (this.sendDataInfo.jurtemre.length < 1) {
				this.$message({
					message: '请选择权限',
					type: 'error'
				});
				return false
			}
			var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))

			if (this.dataActionBox.actionType == 0) {
				var responseData = await this.$http.addJurisdictionTemplate(sendDataInfo)
			} else {
				var responseData = await this.$http.setJurisdictionTemplate(sendDataInfo)
			}
			if (responseData.status == 200) {
				this.$message({
					message: '保存成功',
					type: 'success'
				});
				this.dataActionBox.showStatus = false
				this.$parent.getDataList()
			} else {
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}

		},




		// 权限处理
		handleJurisdiction(data, id = 0, lev = 0) {
			var son = []
			data.forEach((value, keys) => {

				if (value['jurParentid'] == id) {
					value['id'] = value['jurId']
					value['value'] = value['jurId']
					value['label'] = value['jurName']

					var list = this.handleJurisdiction(data, value['jurId'], lev + 1);
					if (list.length >= 1) {
						value['children'] = this.handleJurisdiction(data, value['jurId'], lev + 1);
					}

					son.push(value)

				}
			})
			return son;
		},





		openBox(cate, oldData = '') {
			if (cate == 0) {
				this.dataActionBox.boxTitle = '新增权限模板'
				this.sendDataInfo.jteId = ""
				this.sendDataInfo.jteName = ""
				this.sendDataInfo.jurtemre = []
				this.userJurisdiction = []
				this.$nextTick(() => {
					this.menuList.forEach((item, index) => {
						this.$refs.menuTree[index].setCheckedKeys([])
					})
				})
			} else {
				this.getJurisdictionList()
				this.dataActionBox.boxTitle = '编辑权限模板'
				this.sendDataInfo.jteId = oldData.jteId
				this.sendDataInfo.jteName = oldData.jteName
				// this.sendDataInfo.jurtemre = oldData.jurtemre
				this.userJurisdiction = oldData.jurtemre
				this.$nextTick(() => {
					this.menuList.forEach((item, index) => {
						this.$refs.menuTree[index].setCheckedKeys([])
						this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
					})
				})
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true

		},



	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getJurisdictionList()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
	},
	beforeCreate() {
	}, //生命周期 - 创建之前
	beforeMount() {
	}, //生命周期 - 挂载之前
	beforeUpdate() {
	}, //生命周期 - 更新之前
	updated() {
	}, //生命周期 - 更新之后
	beforeDestroy() {
	}, //生命周期 - 销毁之前
	destroyed() {
	}, //生命周期 - 销毁完成
	activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.el-cascader .el-cascader__tags {
	max-height: 300px !important;
	overflow-y: scroll !important;
}

.jurisdiction_box_one {
	padding: 1rem;
}

.jurisdiction_one {
	width: 100%;
	margin-bottom: .2rem;
}

.jurisdiction_three_box {
	padding: .5rem 0;
}

#qx .el-tabs__header {
	height: auto !important;
}
</style>